import { log } from 'log';
import { useEffect } from 'react';

export const useUnmountSportsbook = () => {
    useEffect(() => () => {
        try {
            window.Sportsbook?.unmountSportsbook();
        } catch (error) {
            log('log', '[SPORTSBOOK | Portal] Unmount sportsbook app error', error);
        }
    }, []);
};
